// frontend/src/pages/GameCenter.tsx

import { GAMES } from '../config/games';
import { GameCard } from '../components/games/GameCard';
import '../styles/games.css';

export function GameCenterPage() {
  return (
    <div className="game-center-page">
      <header className="game-center-header">
        <h1>Oyun Merkezi 🎮</h1>
        <p>Eğlenerek öğren! Aşağıdaki oyunlardan birini seç ve oynamaya başla.</p>
      </header>

      <div className="game-center-grid">
        {GAMES.map((game) => (
          <GameCard key={game.id} game={game} />
        ))}
      </div>
    </div>
  );
}
